export function activateMainBannerPreview() {
    document.querySelectorAll('.main-banner-preview--js').forEach(setupPreview);
}

function setupPreview(preview) {
    const stacks = [...preview.querySelectorAll('.banner-stack')].map((stack) => ({
        element: stack,
        layers: [...stack.querySelectorAll('img')],
    }));
    const picker = [...preview.querySelectorAll('.banner-picker img')];
    const badge = preview.querySelector('.price-badge');

    if (stacks.length === 0 || !badge) return;

    const steps = stacks.flatMap((stack) => stack.layers.map((image, layer) => ({ stack, layer, price: image.dataset.price })));
    const dwell = Number(preview.dataset.dwell) || 1800;
    let index = 0;
    let priceTimer;

    apply(false);

    setInterval(() => {
        if (document.hidden) return;
        index = (index + 1) % steps.length;
        apply(true);
    }, dwell);

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) return;
        clearTimeout(priceTimer);
        settleBadge();
    });

    function apply(animate) {
        const step = steps[index];

        stacks.forEach((stack) => {
            stack.element.classList.toggle('active', stack === step.stack);
            if (stack === step.stack) stack.layers.forEach((image, i) => image.classList.toggle('active', i <= step.layer));
        });
        picker.forEach((image, i) => image.classList.toggle('active', i === index));

        clearTimeout(priceTimer);

        if (!animate) {
            setPrice(step.price, false);
            return;
        }

        priceTimer = setTimeout(() => setPrice(step.price, true), 100);
    }

    function setPrice(price, animate) {
        if (!price || badge.dataset.price === price) return;
        badge.dataset.price = price;

        const spans = [...badge.querySelectorAll('.price-text')];
        spans.slice(0, -1).forEach((stale) => stale.remove());

        const leaving = spans[spans.length - 1];

        if (!animate) {
            if (leaving) {
                leaving.className = 'price-text';
                leaving.textContent = price;
            }
            return;
        }

        if (leaving) {
            leaving.className = 'price-text badge-slide-out';
            leaving.addEventListener('animationend', () => leaving.remove(), { once: true });
        }

        const incoming = document.createElement('span');
        incoming.className = 'price-text badge-slide-in';
        incoming.textContent = price;
        incoming.addEventListener('animationend', () => incoming.classList.remove('badge-slide-in'), { once: true });
        badge.append(incoming);
    }

    function settleBadge() {
        const spans = [...badge.querySelectorAll('.price-text')];
        spans.slice(0, -1).forEach((stale) => stale.remove());

        const kept = spans[spans.length - 1];
        if (!kept) return;

        kept.className = 'price-text';
        kept.textContent = badge.dataset.price;
    }
}
